import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16c67511"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "intro" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1))
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = {
  key: 0,
  class: "actions"
}
const _hoisted_5 = {
  key: 1,
  class: "actions"
}

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAppState, useGameState } from '@/services/composition';
import UIIntroSteps from '@/components/UIIntroSteps/UIIntroSteps.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n()
const { send } = useAppState()
const state = useGameState()

const step = ref(1)
const stepCount = ref(3)

const next = () => {
  send('GAME_COMPANION_INTRO_NEXT_STEP')
  if(step.value > stepCount.value) return
  step.value ++
}

return (_ctx: any,_cache: any) => {
  const _component_ui_btn = _resolveComponent("ui-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_unref(state).matches('intro.companion.wait_xr'))
        ? (_openBlock(), _createBlock(UIIntroSteps, {
            key: 0,
            step: step.value,
            "step-count": stepCount.value,
            onNext: next
          }, null, 8, ["step", "step-count"]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (!_unref(state).matches('intro.companion.wait_xr'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_ui_btn, {
                  class: "btn-skip",
                  variant: "secondary",
                  color: "dark-red",
                  onClick: next
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('intro.skip')), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('tuto.companion.action')), 1))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})